import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
